import React from 'react';
import TutorFilterDatePicker from './DatePicker';
import TutorFilterDurationPicker from './DurationPicker';
import TutorFilterTimeRangePicker from './TimeRangePicker';
import TutorFilterMobile from './Mobile';
import { withTranslation, WithTranslation } from 'next-i18next';

interface TutorFilterOwnProps {
  chosenTimeRange?: number[];
  chosenDate?: string | number | string[];
  chosenTime?: string | number;
  chosenDuration?: string | number;
  timeZone?: string;
  handleMoveRange?: (range: number[]) => void;
  onUpdateChosenDate?: (date: string | number | string[]) => void;
  onUpdateChosenDuration?: (duration: string | number) => void;
  onUpdateChosenTimeRange?: (range: number[]) => void;
}

type TutorFilterProps = TutorFilterOwnProps & WithTranslation;

const TutorFilter = (props: TutorFilterProps) => {
  const {
    chosenTime,
    chosenDate,
    chosenTimeRange,
    chosenDuration,
    onUpdateChosenDate,
    onUpdateChosenTimeRange,
    onUpdateChosenDuration,
    handleMoveRange,
    timeZone,
  } = props;

  const updateChosenDate = (date: string | number | string[]) => {
    onUpdateChosenDate(date);
  };

  const updateChosenTimeRange = (range: number[]) => {
    onUpdateChosenTimeRange(range);
  };

  const updateChosenDuration = (duration: string | number) => {
    onUpdateChosenDuration(duration);
  };

  const tutorFilterSMProps = {
    min: 1,
    max: 49,
    timeZone,
    chosenDate,
    chosenTime,
    chosenDuration,
    chosenTimeRange,
    handleMoveRange,
    updateChosenDate,
    updateChosenTimeRange,
    updateChosenDuration,
  };
  return (
    <div className="tutor-filter-wrapper bg-white">
      <div className="tutor-filter-nav hidden md:block border-b border-light-gray">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="grid grid-cols-12 gap-0">
            <div className="col-span-12 lg:col-span-2 md:col-span-3">
              <TutorFilterDatePicker
                chosenDate={chosenDate}
                updateChosenDate={updateChosenDate}
                timezone={timeZone}
              />
            </div>
            <div className="col-span-12 lg:col-span-2 md:col-span-3">
              <TutorFilterTimeRangePicker
                min={1}
                max={49}
                chosenTimeRange={chosenTimeRange}
                handleMoveRange={handleMoveRange}
                updateChosenTimeRange={onUpdateChosenTimeRange}
              />
            </div>
            <div className="col-span-12 lg:col-span-2 md:col-span-3">
              <TutorFilterDurationPicker
                updateChosenDuration={updateChosenDuration}
                chosenDuration={chosenDuration}
              />
            </div>
          </div>
        </div>
      </div>
      <TutorFilterMobile {...tutorFilterSMProps} />
    </div>
  );
};

export default withTranslation('common')(TutorFilter);
